export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/invite-new-user' */ './InviteNewUser'
  );
